export const form1 = [
  {
    key: 'title',
    value: undefined,
    type: 'Input',
    label: '作品名称',
    placeholder: '请输入作品名称',
    require: true,
  },
  {
    key: 'name',
    value: undefined,
    type: 'Input',
    label: '作者名字',
    placeholder: '请输入作者名字',
    require: true,
  },
  {
    key: 'contact',
    value: undefined,
    type: 'Input',
    label: '联系方式',
    placeholder: '请输入联系方式',
    require: true,
  },
  {
    key: 'teacher',
    value: undefined,
    type: 'Input',
    label: '指导教师',
    placeholder: '请输入教师名字',
    require: true,
  },
  {
    key: 'school',
    value: undefined,
    type: 'Input',
    label: '所属院校',
    placeholder: '请输入学校名称',
    require: true,
  },
  {
    key: 'class',
    value: undefined,
    type: 'Input',
    label: '年级',
    placeholder: '请输入年级',
    require: true,
  },
  {
    key: 'education',
    value: undefined,
    type: 'Select',
    label: '学历',
    placeholder: '请选择学历',
    require: true,
    options: [],
  },
  {
    key: 'files',
    value: undefined,
    type: 'image',
    min: 0,
    max: 8,
    label: '上传作品',
    accept: 'image/jpeg,image/jpg',
    placeholder:
      '图片长边不低于3000像素，分辨率不低于300DPI，RGB模式，JPG或JPEG格式，单张大小在2一8MB之间',
    require: true,
  },
  {
    key: 'introduction',
    value: undefined,
    type: 'InputText',
    label: '简介',
    placeholder: '请输入简介',
    require: true,
    max: 300,
  },
  {
    key: 'is_ai',
    value: 1,
    type: 'Radio',
    label: '是否使用人工智能',
    placeholder: '',
    require: true,
  },
  {
    key: 'tools',
    value: undefined,
    type: 'Input',
    label: '提示词',
    placeholder: '请输入相关工具、提示词',
  },
  {
    key: 'cover',
    value: undefined,
    type: 'image',
    min: 0,
    max: 50,
    fileType: 0,
    label: '生成截图',
    placeholder: '工具、提示词、生成截图等信息',
  },
  {
    key: 'over_url',
    value: undefined,
    type: 'Input',
    label: '生成结果链接',
    placeholder: '若生成结果有链接，需要提供链接',
  },
  {
    key: 'contents',
    value: undefined,
    type: 'InputText',
    label: '文字说明',
    placeholder: '请在此输入作品简介，300字以内',
    max: 300,
  },
];
export const form3 = [
  {
    key: 'title',
    value: undefined,
    type: 'Input',
    label: '作品名称',
    placeholder: '请输入作品名称',
    require: true,
  },
  {
    key: 'name',
    value: undefined,
    type: 'Input',
    label: '作者名字',
    placeholder: '请输入作者名字',
    require: true,
  },
  {
    key: 'contact',
    value: undefined,
    type: 'Input',
    label: '联系方式',
    placeholder: '请输入联系方式',
    require: true,
  },
  {
    key: 'teacher',
    value: undefined,
    type: 'Input',
    label: '指导教师',
    placeholder: '请输入教师名字',
    require: true,
  },
  {
    key: 'school',
    value: undefined,
    type: 'Input',
    label: '所属院校',
    placeholder: '请输入学校名称',
    require: true,
  },
  {
    key: 'class',
    value: undefined,
    type: 'Input',
    label: '年级',
    placeholder: '请输入年级',
    require: true,
  },
  {
    key: 'education',
    value: undefined,
    type: 'Select',
    label: '学历',
    placeholder: '请选择学历',
    require: true,
    options: [],
  },
  {
    key: 'explanation',
    value: undefined,
    type: 'image',
    min: 0,
    max: 5,
    label: '作品封面',
    fileType: 0,
    accept: 'image/jpeg,image/jpg,image/png',
    placeholder: '图片大小控制在5M以内，图片格式JPG、PNG',
    require: true,
  },
  {
    key: 'files',
    value: undefined,
    type: 'image',
    min: 0,
    max: 100,
    label: '上传视频',
    fileType: 1,
    accept: 'video/mp4',
    placeholder: '时长30秒至3分钟，MP4格式，分辨率不低于1080P',
    require: true,
  },

  {
    key: 'introduction',
    value: undefined,
    type: 'InputText',
    label: '简介',
    placeholder: '请输入简介',
    require: true,
    max: 300,
  },
  {
    key: 'is_ai',
    value: 1,
    type: 'Radio',
    label: '是否使用人工智能',
    placeholder: '',
    require: true,
  },
  {
    key: 'tools',
    value: undefined,
    type: 'Input',
    label: '提示词',
    placeholder: '请输入相关工具、提示词',
  },
  {
    key: 'cover',
    value: undefined,
    type: 'image',
    min: 0,
    max: 50,
    fileType: 0,
    label: '生成截图',
    placeholder: '工具、提示词、生成截图等信息',
  },
  {
    key: 'over_url',
    value: undefined,
    type: 'Input',
    label: '生成结果链接',
    placeholder: '若生成结果有链接，需要提供链接',
  },
  {
    key: 'contents',
    value: undefined,
    type: 'InputText',
    label: '文字说明',
    placeholder: '请在此输入作品简介，300字以内',
    max: 300,
  },
];
export const form2 = [
  {
    key: 'title',
    value: undefined,
    type: 'Input',
    label: '作品名称',
    placeholder: '请输入作品名称',
    require: true,
  },
  {
    key: 'name',
    value: undefined,
    type: 'Input',
    label: '作者名字',
    placeholder: '请输入作者名字',
    require: true,
  },
  {
    key: 'contact',
    value: undefined,
    type: 'Input',
    label: '联系方式',
    placeholder: '请输入联系方式',
    require: true,
  },
  {
    key: 'teacher',
    value: undefined,
    type: 'Input',
    label: '指导教师',
    placeholder: '请输入教师名字',
    require: true,
  },
  {
    key: 'school',
    value: undefined,
    type: 'Input',
    label: '所属院校',
    placeholder: '请输入学校名称',
    require: true,
  },
  {
    key: 'class',
    value: undefined,
    type: 'Input',
    label: '年级',
    placeholder: '请输入年级',
    require: true,
  },
  {
    key: 'education',
    value: undefined,
    type: 'Select',
    label: '学历',
    placeholder: '请选择学历',
    require: true,
    options: [],
  },
  {
    key: 'explanation',
    value: undefined,
    type: 'ppt',
    label: '作品说明',
    placeholder: '不超过10页，涵盖设计逻辑、数据来源及视觉呈现',
    require: true,
  },
  {
    key: 'files',
    value: undefined,
    type: 'image',
    min: 0,
    max: 20,
    label: '上传作品',
    showRatio: true,
    fileType: 0,
    accept: 'image/jpeg,image/jpg,image/png',
    placeholder: '文件大小不超过20M\n总长宽比不低于1:20，短边不超过1260px',
    require: true,
  },
  {
    key: 'is_ai',
    value: 1,
    type: 'Radio',
    label: '是否使用人工智能',
    placeholder: '',
    require: true,
  },
  {
    key: 'tools',
    value: undefined,
    type: 'Input',
    label: '提示词',
    placeholder: '请输入相关工具、提示词',
  },
  {
    key: 'cover',
    value: undefined,
    type: 'image',
    min: 0,
    max: 50,
    fileType: 0,
    label: '生成截图',
    placeholder: '工具、提示词、生成截图等信息',
  },
  {
    key: 'over_url',
    value: undefined,
    type: 'Input',
    label: '生成结果链接',
    placeholder: '若生成结果有链接，需要提供链接',
  },
  {
    key: 'contents',
    value: undefined,
    type: 'InputText',
    label: '文字说明',
    placeholder: '请在此输入作品简介，300字以内',
    max: 300,
  },
  // {
  //   key: 'introduction',
  //   value: undefined,
  //   type: 'InputText',
  //   label: '简介',
  //   placeholder: '请输入简介',
  //   require: true,
  //   max: 300,
  // },
];
export const form4 = [
  {
    key: 'title',
    value: undefined,
    type: 'Input',
    label: '作品名称',
    placeholder: '请输入作品名称',
    require: true,
  },
  {
    key: 'name',
    value: undefined,
    type: 'Input',
    label: '作者名字',
    placeholder: '请输入作者名字',
    require: true,
  },
  {
    key: 'contact',
    value: undefined,
    type: 'Input',
    label: '联系方式',
    placeholder: '请输入联系方式',
    require: true,
  },
  {
    key: 'teacher',
    value: undefined,
    type: 'Input',
    label: '指导教师',
    placeholder: '请输入教师名字',
    require: true,
  },
  {
    key: 'school',
    value: undefined,
    type: 'Input',
    label: '所属院校',
    placeholder: '请输入学校名称',
    require: true,
  },
  {
    key: 'class',
    value: undefined,
    type: 'Input',
    label: '年级',
    placeholder: '请输入年级',
    require: true,
  },
  {
    key: 'education',
    value: undefined,
    type: 'Select',
    label: '学历',
    placeholder: '请选择学历',
    require: true,
    options: [],
  },
  {
    key: 'files',
    value: [{ imageUrl: '', description: undefined }],
    type: 'imageInput',
    min: 0,
    max: 20,
    maxNum: 1,
    label: '上传作品',
    fileType: 0,
    accept: 'image/jpeg,image/jpg,image/png',
    placeholder: '',
    require: true,
  },
  {
    key: 'introduction',
    value: undefined,
    type: 'InputText',
    label: '简介',
    placeholder: '请输入简介',
    require: true,
    max: 300,
  },
  {
    key: 'is_ai',
    value: 1,
    type: 'Radio',
    label: '是否使用人工智能',
    placeholder: '',
    require: true,
  },
  {
    key: 'tools',
    value: undefined,
    type: 'Input',
    label: '提示词',
    placeholder: '请输入相关工具、提示词',
  },
  {
    key: 'cover',
    value: undefined,
    type: 'image',
    min: 0,
    max: 50,
    fileType: 0,
    label: '生成截图',
    placeholder: '工具、提示词、生成截图等信息',
  },
  {
    key: 'over_url',
    value: undefined,
    type: 'Input',
    label: '生成结果链接',
    placeholder: '若生成结果有链接，需要提供链接',
  },
  {
    key: 'contents',
    value: undefined,
    type: 'InputText',
    label: '文字说明',
    placeholder: '请在此输入作品简介，300字以内',
    max: 300,
  },
];
export const form5 = [
  {
    key: 'title',
    value: undefined,
    type: 'Input',
    label: '作品名称',
    placeholder: '请输入作品名称',
    require: true,
  },
  {
    key: 'name',
    value: undefined,
    type: 'Input',
    label: '作者名字',
    placeholder: '请输入作者名字',
    require: true,
  },
  {
    key: 'contact',
    value: undefined,
    type: 'Input',
    label: '联系方式',
    placeholder: '请输入联系方式',
    require: true,
  },
  {
    key: 'teacher',
    value: undefined,
    type: 'Input',
    label: '指导教师',
    placeholder: '请输入教师名字',
    require: true,
  },
  {
    key: 'school',
    value: undefined,
    type: 'Input',
    label: '所属院校',
    placeholder: '请输入学校名称',
    require: true,
  },
  {
    key: 'class',
    value: undefined,
    type: 'Input',
    label: '年级',
    placeholder: '请输入年级',
    require: true,
  },
  {
    key: 'education',
    value: undefined,
    type: 'Select',
    label: '学历',
    placeholder: '请选择学历',
    require: true,
    options: [],
  },
  {
    key: 'exp_url',
    value: undefined,
    type: 'Input',
    label: '成果链接',
    placeholder: '请输入成果链接',
    require: true,
  },
  {
    key: 'explanation',
    value: undefined,
    type: 'image',
    min: 0,
    max: 5,
    label: '作品封面',
    fileType: 0,
    accept: 'image/jpeg,image/jpg,image/png',
    placeholder: '图片大小控制在5M以内，图片格式JPG、PNG',
    require: true,
  },
  {
    key: 'files',
    value: undefined,
    type: 'image',
    min: 0,
    max: 100,
    label: '上传视频',
    fileType: 1,
    accept: 'video/mp4',
    placeholder: '时长30秒至3分钟，MP4格式，分辨率不低于1080P',
    require: true,
  },
  {
    key: 'introduction',
    value: undefined,
    type: 'InputText',
    label: '简介',
    placeholder: '请输入简介',
    require: true,
    max: 300,
  },
];
